/*
 *  Document   : consultant-clients.js
 *  Author     : bdsa
 *
 */

// Import required modules
import ExaHelpers from "../exa_helpers";

export default class ConsultantClients {
    /*
    * Auto called when creating a new instance
    *
    */
    constructor() {
        window["ConsultantClients"] = this;
        this.init();
    }

    init() {
        $('.js-dataTable-full-pagination').DataTable({
            ajax: datatablesAjax,
            order: [[5, "desc"]],
            language: {
                url: Laravel.datatablesLanguage
            },
            columns: [
                {
                    data: "user",
                    render: function (data, type, row) {
                        return data ? `<a href="#" class="empty-link" data-target="#consultant-clients-edit-client-modal"
                        data-remote="${clientEditUrl.replace('/id', '/' + row.user.id)}#client-data" data-toggle="modal" >${row.user.last_name} ${row.user.first_name}</a>` : '';
                    }
                },
                {
                    data: "user.email",
                    render: function (data, type, row) {
                        return `<a href="mailto:${data ? data : ''}" class="text-color-table">${data ? data : ''}</a>`
                    }
                },
                {
                    data: "user.mobile_number",
                    render: function (data, type, row) {
                        return `<a href="tel:${data ? data : ''}" class="text-color-table">${data ? data : ''}</a>`
                    }
                },
                {
                    data: "company",
                    render: function (data, type, row) {
                        return data ? `<span class="empty-link" data-target="#consultant-clients-edit-client-modal"
                        data-remote="${companyEditUrl.replace('/id', '/' + row.company.id)}" data-toggle="modal" >${row.company.name}</span>` : '';
                    }
                },
                { data: "user.full_name" },
                { data: "user.id" },
            ],
             "columnDefs": [
                {
                    "targets": [ 3 ],
                    "visible": true,
                    "searchable": true
                },
                {
                    "targets": [ 4 ],
                    "visible": false,
                    "searchable": true
                },
                {
                    "targets": [ 5 ],
                    "visible": false,
                    "searchable": true
                }
            ],
            drawCallback: function () { if (!this.api().data().length) $('.dataTables_paginate .pagination').css('visibility', 'hidden') },
            processing: true,
            serverSide: true,
            lengthChange: false,
            autoWidth: false,
            responsive: true
        });

        let $editCompanyModal = $('#consultant-clients-edit-client-modal');

        $editCompanyModal.on('show.bs.modal', function (e) {

            let $modal = $(e.target);
            let $target = $(e.relatedTarget).first();
            let iframeId = '_' + Math.random().toString(36).substr(2, 9);

            $modal.find('.modal-content').html(`<iframe src="${$target.data('remote')}?minimal_layout=true" onload="adaptIframe()" id="${iframeId}"></iframe>`);
            let $iframe = $('#' + iframeId);
            $iframe.hide();

            window.adaptIframe = function () {
                if(window.frames.length){
                    window.frames[window.frames.length-1].onerror = window.onerror;
                }

                $iframe.contents().find("head")
                    .append($(`
                    <style type='text/css'>
                        html { overflow-x: hidden; }
                        #main-container { margin-bottom: 12px; }
                        #page-container.page-header-fixed #main-container {
                            padding-top: 0;
                        }
                        #sidebar, #page-header, #page-footer, .sidebar, .main-header {
                            display:none !important;
                        }
                        #page-container.sidebar-o {
                            padding-left: 0;
                        }
                        .main-container {
                            left: 0px !important;
                            top: 0px !important;
                            padding: 0 60px !important;
                            margin-left: 0px !important;
                            margin-top: 0px !important;
                            margin-bottom: 26px;
                            max-width: 99% !important;
                        }
                        .layout-container.view {
                            max-width: 100% !important
                        }
                        @media(max-width:992px) { .main-container { padding: 0 !important; } }
                     </style>`));
                $iframe.show();
                $iframe.height('67.5vh');
                $iframe.css('border', 0);

                // Setting it to iframe contents height is too low
                // $iframe.height($iframe.contents().height());
            };
        });
    }
}
